import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GROUPS_QUERY_KEY } from '../../services/bindDomainMembershipKeys';
import {
  GroupsListParams,
  ListGroupMembershipsResponse,
  ListGroupsResponse,
  listGroupMemberships,
  listGroups,
} from '../../services/groupsService';

export const groupsKeys = {
  all: GROUPS_QUERY_KEY,
  list: (params: GroupsListParams) =>
    [...groupsKeys.all, 'list', params] as const,
  memberships: (groupId: number | null, params: GroupsListParams) =>
    [...groupsKeys.all, groupId, 'memberships', params] as const,
};

export const useGroups = (params: GroupsListParams, enabled: boolean) =>
  useQuery<ListGroupsResponse, Error>({
    queryKey: groupsKeys.list(params),
    queryFn: () => listGroups(params),
    enabled,
    networkMode: 'always',
    placeholderData: keepPreviousData,
  });

export const useGroupMemberships = (
  groupId: number | null,
  params: GroupsListParams,
  enabled: boolean,
) =>
  useQuery<ListGroupMembershipsResponse, Error>({
    queryKey: groupsKeys.memberships(groupId, params),
    queryFn: () => listGroupMemberships(groupId!, params),
    enabled: enabled && groupId !== null,
    networkMode: 'always',
    placeholderData: (previousData, previousQuery) =>
      previousQuery?.queryKey[1] === groupId ? previousData : undefined,
  });
